import { useEffect, useState } from "react";
import { getAnnouncements } from "../components/api";
import Cookies from 'universal-cookie';
import { setUnreadAnnouncementsCount } from "../store/announcements";
import "../styles/main.scss"
import { Announcement } from "../components/Announcement";
const cookies = new Cookies();

const STORAGE_URL = process.env.REACT_APP_STORAGE_PATH;

export const Main = () => {
    const [announcements, setAnnouncements] = useState([]);
    const [readedAnnouncements, setReadedAnnouncements] = useState([])

    useEffect(() => {
        getAnnouncements()
            .then(data => {
                const announcementsFromCookies = cookies.get('readedAnnouncements');
                const newReadedAnnouncements = announcementsFromCookies
                    ? String(announcementsFromCookies).includes(",") ?
                        announcementsFromCookies.split(',').map(Number)
                        : [Number(announcementsFromCookies)]
                    : [];

                const announcementIds = data.map(announcement => announcement.id);
                if (announcementIds.length && !newReadedAnnouncements.includes(announcementIds[0])) {
                    newReadedAnnouncements.push(announcementIds[0]);
                }

                setReadedAnnouncements(newReadedAnnouncements);

                const announcements = Array.from(data).map(announcement => {
                    return {
                        id: announcement.id,
                        image: `${STORAGE_URL}/${announcement.image}`,
                        title: announcement.title,
                        text: announcement.text,
                        date: announcement.date
                    }
                });
                setAnnouncements(announcements);

                const unreadCount = calculateUnreadAnnouncementsCount(announcementIds, newReadedAnnouncements);
                setUnreadAnnouncementsCount(unreadCount);
                cookies.set('readedAnnouncements', newReadedAnnouncements.join(','));
            })
    }, []);

    const calculateUnreadAnnouncementsCount = (announcementIds, readedAnnouncementsList) => {
        return announcementIds.filter(id => !readedAnnouncementsList.includes(id)).length;
    };

    const handleAnnouncementView = (id) => {
        const newReadedAnnouncements = readedAnnouncements;
        if (!readedAnnouncements.includes(id)) {
            readedAnnouncements.push(id);
            const announcementIds = announcements.map(announcement => announcement.id);
            setReadedAnnouncements(newReadedAnnouncements);
            const unreadCount = calculateUnreadAnnouncementsCount(announcementIds, newReadedAnnouncements);          
            setUnreadAnnouncementsCount(unreadCount);
            cookies.set('readedAnnouncements', newReadedAnnouncements.join(','));
        }
    }

    return (
        <div className="main">
            {announcements.map(announcement => (
                <Announcement key={announcement.id} announcement={announcement} onTrackView={handleAnnouncementView} ></Announcement>
            ))}       
        </div>
    )
}